<template>
  <dialog-editor 
  :item.sync="modalOpen" 
  :name="tag?.id!==undefined ? 'Редактировать тег #'+tag.id : 'Добавить тег'" 
  width="800"
  :submitText="isValid ? 'Сохранить' :  null" 
  @submit="isValid ? tagCreateOrUpdate() : null"
  content-padding-remove>
    <template v-slot:actions>
        <btn-icon-accept v-if="tag?.id!==undefined"  icon="mdi-trash-can-outline" text="Удалить тег?" @accept="tagDelete()"/>
    </template>

    <div v-if="localTag" class="px-3 py-5">
        <text-field name="Имя" :value.sync="localTag.name" required/>
        <text-field name="Длительность (дней)" :value.sync="localTag.durationDays" format="^[0-9]+$" formatExample="1000"/>
          <autocomplete-single
            name="Тип"
            :items="[{id:'user',name:'Пользователь'},{id:'medPlan',name:'Мед.план'}]"
            :select.sync="localTag.type"
            backgroundColor="white"
            required
        >
        </autocomplete-single>
        <label-view title="Цвет">
          <template v-slot:content>
            <v-color-picker v-model="localTag.color" mode="hexa" :hide-canvas="false" hide-inputs :hide-sliders="false" show-swatches :swatches="swatches"/>
          </template>
        </label-view>
    </div>
  </dialog-editor>

</template>

<script>
import Api from "@/Api";
import State from "@/plugins/state";
import DialogEditor from "@/componentsV2/base/DialogEditor.vue";
import BtnIconAccept from "@/componentsV2/base/BtnIconAccept.vue";
import TextField from "@/componentsV2/base/TextField.vue";
import AutocompleteSingle from "@/componentsV2/base/AutocompleteSingle.vue";
import LabelView from "@/components/LabelView";


export default {
  components: {
    DialogEditor,
    BtnIconAccept,
    TextField,
    AutocompleteSingle,
    LabelView 
  },
  props: ['tag'],
  data: () => ({
    modalOpen: null,
    loadState:new State(),
    deleteState:new State(),
    localTag: null,
    isValid: true,
    swatches: [
      ['#f44336','#ef9a9a'],
      ['#2196f3','#90caf9'],
      ['#4caf50','#a5d6a7'],
      ['#ffc107','#ffe082'],
      ['#9e9e9e','#eeeeee'],
    ],
  }),
  watch: {
    tag() {
      if (this.tag!=null) {
        this.modalOpen = true;
        this.emptyTag();

        this.localTag = Object.assign({}, this.tag);

      }  
    },
    modalOpen(v){
      if (!this.localTag.color||typeof this.localTag.color === 'object')
        this.localTag.color = '#eeeeee';
      if (v===null) 
        this.$emit('update:tag',null)
    },
  },
  methods: {
    emptyTag() {
      this.localTag = {
        name:null,
        durationDays:null,
        color: null,
        type: null
      }
    },
    tagCreateOrUpdate(){
      this.loadState.stateLoading();

      let data = {
        name: this.localTag.name,
        durationDays: this.localTag.durationDays === '' ? null : this.localTag.durationDays,
        type: this.localTag.type.id,
        color: this.localTag.color,
      }

      if (this.localTag?.id===undefined) {
        Api.service.tag.create(data, ()=> {
          this.$emit('update');
          this.modalOpen = null;
          this.loadState.stateSuccess();
        },()=> {
          this.deleteState.stateError();
        });
      } else {      
        Api.service.tag.update(this.localTag.id, data, ()=> {
          this.$emit('update');
          this.modalOpen = null;
          this.loadState.stateSuccess();
        },()=> {
          this.deleteState.stateError();
        });
      }
    },
    tagDelete(){
      this.deleteState.stateLoading();
      Api.service.tag.delete(this.localTag.id, ()=> {
        this.$emit('update');
        this.modalOpen = null;
        this.deleteState.stateSuccess();
      },()=> {
        this.deleteState.stateError();
      });
    },
    // validation() {
    //   this.isValid = true;
    //   if (this.localTag.defaultStartDate&&this.localTag.defaultEndDate) {
    //     const start = moment(this.localTag.defaultStartDate,'DD.MM.YYYY')
    //     const end = moment(this.localTag.defaultEndDate,'DD.MM.YYYY')
    //     if (start.isAfter(end)) {
    //       this.$store.commit('alertWarning', 'Диапазон задан неверно');
    //       this.isValid = false 
    //     }
    //   }
    // }  
  }
}
</script>